// Ported from `app/n5/page.tsx` in `git@git.fugl.dev:sks/yominoki.git` @
// `515ce239`.
//
// Almost all of that page was server work — `listTreemap`, `composeBatch`,
// the median, and the preload fan-out over every visible lemma — and all of it
// is `GET /api/n5/batch` now (../../worker/routes/territory.ts). What is left
// here is the page: read `?map=`, render the map, and hand `TerritoryMap` the
// same four props it always took.
//
// The territory is PUBLIC on purpose and this page does not gate on a session:
// the layout is derived from aggregate token_frequency × jlpt_vocab and
// reveals nothing about a reader. The endpoint applies the gate that matters —
// an anonymous visitor gets `preloadedSentences: {}` — which is exactly what
// the server component did.

import { useSearchParams } from "react-router";
import { TerritoryMap } from "../components/n5/territory-map";
import { useResource } from "../hooks/use-resource";
import { getN5Batch, getTopSentences } from "../lib/api";

const SATURATION_RATIO = 0.75;

export function N5Page() {
  const [params] = useSearchParams();
  // Same coercion the page used: anything unparseable is map 1, so a
  // hand-typed `?map=banana` still draws a map.
  const mapNumber = Math.max(1, Math.floor(Number(params.get("map"))) || 1);

  const { resource } = useResource(
    (signal) => getN5Batch(mapNumber, signal),
    [mapNumber],
  );

  if (resource.status === "loading") {
    return (
      <main className="bg-paper text-ink flex h-svh items-center justify-center">
        <p className="n5-marginalia">drawing the map…</p>
      </main>
    );
  }
  if (resource.status === "error") {
    return (
      <main className="bg-paper text-ink flex h-svh items-center justify-center">
        <p className="n5-marginalia">the map could not be drawn</p>
      </main>
    );
  }

  const { batchId, entries, preloadedSentences } = resource.data;

  return (
    <main className="bg-paper text-ink flex h-svh flex-col">
      {/* `key` on the batch id, not an effect that resets state field by
          field: a new map is a semantically different entity, and the session
          reducer, the sentence cache and the wash tokens inside must all start
          over. This is the `key` case from the effect policy's §1.3. */}
      <TerritoryMap
        key={batchId}
        batchId={batchId}
        mapNumber={mapNumber}
        entries={entries}
        saturationRatio={SATURATION_RATIO}
        fetchSentences={getTopSentences}
        preloadedSentences={preloadedSentences}
      />
    </main>
  );
}
